window.addEventListener('load', () => {
  class VideoControls extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const section = this.closest('section');
      const videoMedias = section.querySelectorAll('video-media');
      const videos = section.querySelectorAll('video');
      
      const playButton = this.querySelector('button[data-action="play"]');
      const pauseButton = this.querySelector('button[data-action="pause"]');
      const muteButton = this.querySelector('button[data-action="mute"]');
      const unmuteButton = this.querySelector('button[data-action="unmute"]');

      playButton.addEventListener('click', () => {
        videoMedias.forEach(videoMedia => videoMedia.play());
        playButton.hidden = true;
        pauseButton.hidden = false;
      });

      pauseButton.addEventListener('click', () => {
        videoMedias.forEach(videoMedia => videoMedia.pause());
        pauseButton.hidden = true;
        playButton.hidden = false;
      });

      muteButton.addEventListener('click', () => {
        videos.forEach(video => video.muted = true);
        muteButton.hidden = true;
        unmuteButton.hidden = false;
      });

      unmuteButton.addEventListener('click', () => {
        videos.forEach(video => video.muted = false);
        unmuteButton.hidden = true;
        muteButton.hidden = false;
      });
    }
  }
  customElements.define('video-controls', VideoControls);
});
